import useHistorySideEffect from './useHistorySideEffect';

interface IProps {
  href: string;
  method?: 'replace' | 'push';
  shouldRedirect?: boolean;
}

export default function HardRedirect({
  method = 'replace',
  href,
  shouldRedirect = true,
}: IProps) {
  useHistorySideEffect((history) => {
    if (!shouldRedirect) {
      return;
    }

    method === 'replace' ? history.hardReplace(href)
                         : history.hardPush(href);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldRedirect]);

  return null;
}
